import { render, staticRenderFns } from "./HistoryMinigame.vue?vue&type=template&id=248446a2&scoped=true"
import script from "./HistoryMinigame.vue?vue&type=script&lang=js"
export * from "./HistoryMinigame.vue?vue&type=script&lang=js"
import style0 from "./HistoryMinigame.vue?vue&type=style&index=0&id=248446a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248446a2",
  null
  
)

export default component.exports